module.exports = __webpack_public_path__ + "static/vakif1-d0114c78f0c7691b7e1f9aad27315b1c.png";